var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',[_c('v-flex',{staticClass:"ma-1",attrs:{"xs12":"","md4":""}},[_c('div',{staticStyle:{"font-style":"italic"}},[_vm._v("Component under construction")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }